module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.product && _vm.currentUser.creator_verified) ? _c('div', {
    staticClass: "page upload-child sell-page product-page mx-5 margin-top-header"
  }, [_c('div', {
    staticClass: "page-content"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": ""
    }
  }, [_c('h2', {
    staticClass: "my-2 album-info-title"
  }, [_vm._v("Info")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "content-section": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm7": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "product-section": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "form-group": ""
    }
  }, [_c('label', {
    staticClass: "control-label max-char-label"
  }, [_c('span', {
    staticClass: "__title"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\tProduct Name\n\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.name),
      expression: "product.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "form-group": ""
    }
  }, [_c('label', {
    staticClass: "control-label max-char-label"
  }, [_c('span', {
    staticClass: "__title"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\tCategory\n\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-select', {
    staticClass: "pt-0",
    attrs: {
      "placeholder": "Select",
      "items": _vm.product_categories,
      "item-text": "name",
      "item-value": "id",
      "no-data-text": "No destination available",
      "autocomplete": ""
    },
    on: {
      "change": _vm.onChangeProductCategory
    },
    model: {
      value: (_vm.product.category),
      callback: function($$v) {
        _vm.$set(_vm.product, "category", $$v)
      },
      expression: "product.category"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "form-group": ""
    }
  }, [_c('label', {
    staticClass: "control-label max-char-label"
  }, [_c('span', {
    staticClass: "__title"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("\n                          Access Level\n                        ")])]), _vm._v(" "), _c('v-select', {
    staticClass: "pt-0",
    attrs: {
      "placeholder": "Select",
      "items": _vm.access_levels,
      "item-text": "title",
      "item-value": "id",
      "no-data-text": "No destination available",
      "autocomplete": ""
    },
    model: {
      value: (_vm.product.access_level),
      callback: function($$v) {
        _vm.$set(_vm.product, "access_level", $$v)
      },
      expression: "product.access_level"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "form-group": ""
    }
  }, [_c('label', {
    staticClass: "control-label max-char-label"
  }, [_c('span', {
    staticClass: "__title"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\tDescription\n\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.description),
      expression: "product.description"
    }],
    staticClass: "product-description form-control non-resizable",
    attrs: {
      "maxlength": "2000"
    },
    domProps: {
      "value": (_vm.product.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "mt-4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "value": "single_order",
      "label": "Only a single product allowed per user"
    },
    model: {
      value: (_vm.product.single_order),
      callback: function($$v) {
        _vm.$set(_vm.product, "single_order", $$v)
      },
      expression: "product.single_order"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticClass: "black--text"
  }, [_vm._v("Check box if you want to limit this product to only one per user")])])], 2)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm5": "",
      "pl-4": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "product-section": ""
    }
  }, [_c('label', {
    staticClass: "control-label max-char-label"
  }, [_c('span', {
    staticClass: "__title"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tProduct Images\n\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-lg": "",
      "px-0": "",
      "pt-0": "",
      "mt-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "product-image-section"
  }, [(_vm.product_image1_url) ? _c('div', {
    staticClass: "product-image",
    style: (("background-image:url(" + _vm.product_image1_url + ")")),
    attrs: {
      "id": "product_image1"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.product_image1_url) ? _c('div', {
    staticClass: "product-image-upload-section"
  }, [_c('input', {
    staticClass: "add-product-image-file",
    attrs: {
      "type": "file",
      "name": "product_image_file",
      "id": "product_image_file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.imageChanged('product_image1', $event)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "product_image_file"
    }
  }, [_c('v-icon', {
    staticClass: "camera"
  }, [_vm._v("photo_camera")]), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tUpload\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "product-image-change-section"
  }, [_c('input', {
    staticClass: "change-product-image-file",
    attrs: {
      "type": "file",
      "name": "product_image_file",
      "id": "product_image_file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.imageChanged('product_image1', $event)
      }
    }
  }), _vm._v(" "), (_vm.product_image1_url) ? _c('label', {
    attrs: {
      "for": "product_image_file"
    }
  }, [_vm._v("Change")]) : _vm._e(), (_vm.product_image1_url) ? _c('label', {
    staticClass: "text-btn",
    on: {
      "click": function($event) {
        _vm.deleteProductImage('product_image1')
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t/ Delete")]) : _vm._e()])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "product-image-section"
  }, [(_vm.product_image2_url) ? _c('div', {
    staticClass: "product-image",
    style: (("background-image:url(" + _vm.product_image2_url + ")")),
    attrs: {
      "id": "product_image2"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.product_image2_url) ? _c('div', {
    staticClass: "product-image-upload-section"
  }, [_c('input', {
    staticClass: "add-product-image-file",
    attrs: {
      "type": "file",
      "name": "product_image_file2",
      "id": "product_image_file2",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.imageChanged('product_image2', $event)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "product_image_file2"
    }
  }, [_c('v-icon', {
    staticClass: "camera"
  }, [_vm._v("photo_camera")]), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tUpload\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "product-image-change-section"
  }, [_c('input', {
    staticClass: "change-product-image-file",
    attrs: {
      "type": "file",
      "name": "product_image_file2",
      "id": "product_image_file2",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.imageChanged('product_image2', $event)
      }
    }
  }), _vm._v(" "), (_vm.product_image2_url) ? _c('label', {
    attrs: {
      "for": "product_image_file2"
    }
  }, [_vm._v("Change")]) : _vm._e(), (_vm.product_image2_url) ? _c('label', {
    staticClass: "text-btn",
    on: {
      "click": function($event) {
        _vm.deleteProductImage('product_image2')
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t/ Delete")]) : _vm._e()])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "product-image-section"
  }, [(_vm.product_image3_url) ? _c('div', {
    staticClass: "product-image",
    style: (("background-image:url(" + _vm.product_image3_url + ")")),
    attrs: {
      "id": "product_image3"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.product_image3_url) ? _c('div', {
    staticClass: "product-image-upload-section"
  }, [_c('input', {
    staticClass: "add-product-image-file",
    attrs: {
      "type": "file",
      "name": "product_image_file3",
      "id": "product_image_file3",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.imageChanged('product_image3', $event)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "product_image_file3"
    }
  }, [_c('v-icon', {
    staticClass: "camera"
  }, [_vm._v("photo_camera")]), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tUpload\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "product-image-change-section"
  }, [_c('input', {
    staticClass: "change-product-image-file",
    attrs: {
      "type": "file",
      "name": "product_image_file3",
      "id": "product_image_file3",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.imageChanged('product_image3', $event)
      }
    }
  }), _vm._v(" "), (_vm.product_image3_url) ? _c('label', {
    attrs: {
      "for": "product_image_file3"
    }
  }, [_vm._v("Change")]) : _vm._e(), (_vm.product_image3_url) ? _c('label', {
    staticClass: "text-btn",
    on: {
      "click": function($event) {
        _vm.deleteProductImage('product_image3')
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t/ Delete")]) : _vm._e()])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "price-option-section": ""
    }
  }, [_c('h2', {
    staticClass: "album-info-title"
  }, [_vm._v("Products (" + _vm._s(_vm.product.variants.length) + ")")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm7": "",
      "mt-4": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "product-section": ""
    }
  }, _vm._l((_vm.product.variants), function(variant, index) {
    return _c('v-layout', {
      key: index,
      attrs: {
        "row": "",
        "product-option-content": "",
        "form-group": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm4": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_c('label', {
      staticClass: "required"
    }, [_vm._v("*")]), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\tOption Name\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
      staticClass: "dflex align-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (variant.name),
        expression: "variant.name"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "disabled": _vm.isDigitalProduct,
        "placeholder": "Large - Black"
      },
      domProps: {
        "value": (variant.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(variant, "name", $event.target.value)
        }
      }
    })])]), _vm._v(" "), (!_vm.isDigitalProduct) ? _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm4": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_c('label', {
      staticClass: "required"
    }, [_vm._v("*")]), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t# In Stock\n\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (variant.quantity),
        expression: "variant.quantity"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "99"
      },
      domProps: {
        "value": (variant.quantity)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(variant, "quantity", $event.target.value)
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm4": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_c('label', {
      staticClass: "required"
    }, [_vm._v("*")]), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tPrice\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "dflex gap-10 align-center"
    }, [_c('span', {
      staticClass: "dflex align-center"
    }, [_c('vue-numeric', {
      staticClass: "form-control primary-input",
      attrs: {
        "currency": "$",
        "currency-symbol-position": "prefix",
        "separator": ",",
        "precision": 2,
        "min": 0
      },
      model: {
        value: (variant.price),
        callback: function($$v) {
          _vm.$set(variant, "price", $$v)
        },
        expression: "variant.price"
      }
    }), _vm._v(" "), _c('v-icon', {
      staticClass: "clear-btn",
      on: {
        "click": function($event) {
          _vm.deleteVariant(index)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tclear\n\t\t\t\t\t\t\t\t\t\t\t\t\t")])], 1), _vm._v(" "), (!_vm.isDigitalProduct) ? _c('v-btn', {
      staticClass: "add-option-btn",
      nativeOn: {
        "click": function($event) {
          _vm.addVariant()
        }
      }
    }, [_c('v-icon', [_vm._v("add")])], 1) : _vm._e()], 1)])], 1)
  }))], 1), _vm._v(" "), (!_vm.isDigitalProduct) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "pa-0": "",
      "mt-5": ""
    }
  }, [_c('h2', {
    staticClass: "album-info-title"
  }, [_vm._v("Tax")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "product-section": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "mt-2": "",
      "product-section": "",
      "mt-4": ""
    }
  }, [_c('v-checkbox', {
    on: {
      "change": _vm.resetTaxPercent
    },
    model: {
      value: (_vm.product.is_vat),
      callback: function($$v) {
        _vm.$set(_vm.product, "is_vat", $$v)
      },
      expression: "product.is_vat"
    }
  }, [_c('template', {
    slot: "label"
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Sellers outside of US check box for VAT/GST")])])], 2)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "mt-3": ""
    }
  }, [(_vm.product.is_vat) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Sellers Country")]), _vm._v(" "), _c('v-select', {
    staticClass: "pt-0",
    attrs: {
      "items": _vm.countries,
      "item-text": "name",
      "item-value": "name",
      "autocomplete": ""
    },
    on: {
      "change": _vm.changeTaxPercent
    },
    model: {
      value: (_vm.product.seller_location),
      callback: function($$v) {
        _vm.$set(_vm.product, "seller_location", $$v)
      },
      expression: "product.seller_location"
    }
  })], 1) : _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Sellers State")]), _vm._v(" "), _c('v-select', {
    staticClass: "pt-0",
    attrs: {
      "placeholder": "CA",
      "items": _vm.states,
      "item-text": "name",
      "item-value": "name",
      "autocomplete": ""
    },
    on: {
      "change": _vm.changeTaxPercent
    },
    model: {
      value: (_vm.product.seller_location),
      callback: function($$v) {
        _vm.$set(_vm.product, "seller_location", $$v)
      },
      expression: "product.seller_location"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [(_vm.product.is_vat) ? _c('label', {
    staticClass: "control-label"
  }, [_vm._v("Tax")]) : _c('label', {
    staticClass: "control-label"
  }, [_vm._v("State Tax")]), _vm._v(" "), _c('vue-numeric', {
    staticClass: "form-control primary-input",
    attrs: {
      "currency": "%",
      "placeholder": "8.5%",
      "currency-symbol-position": "suffix",
      "separator": ",",
      "precision": 3,
      "min": 0,
      "max": 100
    },
    model: {
      value: (_vm.product.tax_percent),
      callback: function($$v) {
        _vm.$set(_vm.product, "tax_percent", $$v)
      },
      expression: "product.tax_percent"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "price-option-section": "",
      "form-group": "",
      "mt-5": ""
    }
  }, [_c('h2', {
    staticClass: "album-info-title"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tShipping & Handling \n\t\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('span', {
    staticClass: "text-muted mt-4"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\tPlease select "), _c('strong', [_vm._v("All other countries")]), _vm._v(" in destination to proceed.\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _vm._l((_vm.product.shipments), function(shipment, index) {
    return _c('v-layout', {
      key: index,
      attrs: {
        "row": "",
        "mt-3": "",
        "product-option-content": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm5": "",
        "pr-2": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("Destination")]), _vm._v(" "), _c('span', {
      staticClass: "dflex align-center"
    }, [_c('v-select', {
      staticClass: "pt-0",
      attrs: {
        "items": _vm.destinations,
        "item-text": "name",
        "item-value": "value",
        "autocomplete": ""
      },
      model: {
        value: (shipment.country),
        callback: function($$v) {
          _vm.$set(shipment, "country", $$v)
        },
        expression: "shipment.country"
      }
    })], 1)]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm4": "",
        "pr-2": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("Shipped Alone")]), _vm._v(" "), _c('vue-numeric', {
      staticClass: "form-control primary-input",
      attrs: {
        "currency": "$",
        "currency-symbol-position": "prefix",
        "separator": ",",
        "precision": 2,
        "min": 0
      },
      model: {
        value: (shipment.shipment_alone_price),
        callback: function($$v) {
          _vm.$set(shipment, "shipment_alone_price", $$v)
        },
        expression: "shipment.shipment_alone_price"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm4": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("With others")]), _vm._v(" "), _c('div', {
      staticClass: "dflex align-center gap-10"
    }, [_c('span', {
      staticClass: "dflex align-center"
    }, [_c('vue-numeric', {
      staticClass: "form-control primary-input",
      attrs: {
        "currency": "$",
        "currency-symbol-position": "prefix",
        "separator": ",",
        "precision": 2,
        "min": 0
      },
      model: {
        value: (shipment.shipment_with_price),
        callback: function($$v) {
          _vm.$set(shipment, "shipment_with_price", $$v)
        },
        expression: "shipment.shipment_with_price"
      }
    }), _vm._v(" "), _c('v-icon', {
      staticClass: "clear-btn",
      on: {
        "click": function($event) {
          _vm.deleteShipment(index)
        }
      }
    }, [_vm._v("clear")])], 1), _vm._v(" "), _c('v-btn', {
      staticClass: "add-option-btn"
    }, [_c('v-icon', [_vm._v("add")])], 1)], 1)])], 1)
  })], 2)], 1) : _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm7": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "section-title": ""
    }
  }, [_c('h4', [_vm._v("Digital Product Upload")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "product-section": ""
    }
  }, [_c('h4', {
    staticClass: "option-title"
  }, [_vm._v(".Zip file only, 2GB max upload")]), _vm._v(" "), _c('digital-uploader', {
    attrs: {
      "digitalContent": _vm.digital_content
    }
  })], 1)], 1), _vm._v(" "), (['pending', 'collaborated'].indexOf(_vm.product.status) != -1) ? _c('v-flex', {
    staticClass: "collaborator-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h4', {
    staticClass: "option-title"
  }, [_vm._v("Collaborators")])]), _vm._v(" "), (
    _vm.product.status == 'pending' && _vm.product.collaborators.length < 3
  ) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "add-option-btn ma-0",
    nativeOn: {
      "click": function($event) {
        _vm.addCollaborator()
      }
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v(" Add another collaborator\n\t\t\t\t\t\t\t\t\t\t")], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "pa-0": ""
    }
  }, [(_vm.product.collaborators && _vm.product.collaborators.length > 0) ? _c('v-layout', {
    attrs: {
      "row": "",
      "creator-wrapper": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Creator"), _c('label', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('label', {
    staticClass: "creator-name"
  }, [_vm._v(_vm._s(_vm.$store.state.auth.user.username))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm3": ""
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Profit Share"), _c('label', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('label', {
    staticClass: "creator-share"
  }, [_vm._v(_vm._s(_vm.creator_share))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm3": ""
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Recoup Cost")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.creator_recoup_cost),
      expression: "product.creator_recoup_cost"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": _vm.product.status != 'pending'
    },
    domProps: {
      "value": (_vm.product.creator_recoup_cost)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "creator_recoup_cost", $event.target.value)
      }
    }
  })])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.product.collaborators), function(collaborator, index) {
    return _c('v-layout', {
      key: index,
      attrs: {
        "row": "",
        "product-option-content": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("Collaborators"), _c('label', {
      staticClass: "required"
    }, [_vm._v("*")])]), _vm._v(" "), _c('v-select', {
      staticClass: "pt-0",
      attrs: {
        "items": _vm.users,
        "item-text": "username",
        "item-value": "id",
        "chips": "",
        "no-data-text": "No collaborator available",
        "disabled": _vm.product.status != 'pending',
        "autocomplete": ""
      },
      scopedSlots: _vm._u([{
        key: "selection",
        fn: function(data) {
          return [_c('v-chip', {
            key: JSON.stringify(data.item),
            staticClass: "chip--select-multi",
            attrs: {
              "selected": data.selected
            },
            on: {
              "input": function($event) {
                data.parent.selectItem(data.item)
              }
            }
          }, [_c('v-avatar', [_c('img', {
            attrs: {
              "src": data.item.avatar.thumb.url
            }
          })]), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(data.item.username) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")], 1)]
        }
      }, {
        key: "item",
        fn: function(data) {
          return [(typeof data.item !== 'object') ? [_c('v-list-tile-content', {
            domProps: {
              "textContent": _vm._s(data.item)
            }
          })] : [_c('v-list-tile-avatar', [_c('img', {
            attrs: {
              "src": data.item.avatar.thumb.url
            }
          })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
            domProps: {
              "innerHTML": _vm._s(data.item.username)
            }
          })], 1)]]
        }
      }]),
      model: {
        value: (collaborator.user_id),
        callback: function($$v) {
          _vm.$set(collaborator, "user_id", $$v)
        },
        expression: "collaborator.user_id"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("Profit Share"), _c('label', {
      staticClass: "required"
    }, [_vm._v("*")])]), _vm._v(" "), _c('v-select', {
      staticClass: "pt-0",
      attrs: {
        "items": _vm.profit_share_types,
        "item-text": "name",
        "item-value": "id",
        "disabled": _vm.product.status != 'pending',
        "autocomplete": ""
      },
      model: {
        value: (collaborator.user_share),
        callback: function($$v) {
          _vm.$set(collaborator, "user_share", $$v)
        },
        expression: "collaborator.user_share"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm3": ""
      }
    }, [_c('label', {
      staticClass: "control-label"
    }, [_vm._v("Status")]), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(collaborator.status) + "\n\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), (_vm.product.status == 'pending') ? _c('v-icon', {
      staticClass: "clear-btn",
      on: {
        "click": function($event) {
          _vm.deleteCollaborator(index)
        }
      }
    }, [_vm._v("clear")]) : _vm._e()], 1)
  })], 2)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "product-save-btn",
    attrs: {
      "disabled": !_vm.isAvailableToUpdateProduct,
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        _vm.beforeSaveProduct()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('a', {
    staticClass: "cancel-button",
    on: {
      "click": function($event) {
        _vm.cancelToSaveProduct()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a4aa63c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/sell/edit_product.vue
// module id = 1712
// module chunks = 180